'use client'

import cx from 'classnames'

import RequiredLabel from '@/components/Form/Atoms/RequiredLabel'
import TextareaBase from '@/components/Form/Atoms/TextareaBase'
import { SurveyQuestionType } from '@/types/surveyQuestion'

export type Props = {
  surveyAnswersKeyName: string
  surveyQuestion: SurveyQuestionType
  index: number | null
}

export default function SurveyFormText({ surveyQuestion, surveyAnswersKeyName, index }: Props) {
  const surveyOption = surveyQuestion.surveyOptions[0]
  return (
    <div className={cx('c-surveyForm-surveyForm__questions')}>
      <label className="c-inputBase__label u-mb14">
        <span>
          {index !== null && <span>{index + 1}. </span>}
          {surveyQuestion.name}
          {surveyQuestion.answerRequired && <RequiredLabel />}
        </span>
      </label>
      <TextareaBase
        name={`${surveyAnswersKeyName}.${surveyQuestion.surveyQuestionId}`}
        placeholder={surveyOption?.name || ''}
        rows={3}
      />
    </div>
  )
}
